import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { CalendarComponent } from "ionic2-calendar/calendar";
import { Evento } from './eventos.modelview';
import { EventosPageProvider } from './eventos.provider';
import * as moment from 'moment';

/**
 * Generated class for the EventosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-eventos',
  templateUrl: 'eventos.html',
})
export class EventosPage {
  @ViewChild(CalendarComponent) myCalendar: CalendarComponent;

  isBrowser: boolean = false
  eventSource: Array<Evento> = [];
  viewTitle: string;
  selectedDay = new Date();

  date_title: string;

  calendar = {
    locale: 'pt_br',
    mode: 'month',
    currentDate: new Date(),
    dateFormatter: {
      formatMonthViewDayHeader: function (date: Date) {
        var weekday = new Array(7);
        weekday[0] = "Dom";
        weekday[1] = "Seg";
        weekday[2] = "Ter";
        weekday[3] = "Qua";
        weekday[4] = "Qui";
        weekday[5] = "Sex";
        weekday[6] = "Sab";

        return weekday[date.getDay()];
      },
      formatMonthViewDay: function (date: Date) {
        return date.getDate().toString();
      }
    }
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public provider: EventosPageProvider,
    public loadingCtrl: LoadingController) {
    this.isBrowser = this.navParams.get("isBrowser")
  }

  ionViewDidLoad() {
    this.myCalendar.loadEvents()
    this.requestEvents()
  }

  requestEvents() {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present()

    this.provider.requestEvents().subscribe((data) => {
      data.map(element => {
        this.eventSource.push({
          title: element.title.rendered,
          event_description: element.content.rendered,
          startTime: moment(element.acf.data, "DD/MM/YYYY").toDate(),
          endTime: moment(element.acf.data_termino, "DD/MM/YYYY").add(1, 'days').toDate(),
          allDay: false
        });
      });
      this.myCalendar.loadEvents()
      loading.dismiss()
    }, (error) => {
      loading.dismiss()
    })
  }
  onEventSelected(event) {

  }
  onViewTitleChanged(event) {

  }
  onTimeSelected(event) {
    console.log(event)
    let selectedDate: Date = event.selectedTime;
    this.date_title = this.getMonthName(selectedDate.getMonth()) + ", " + selectedDate.getFullYear()
  }

  previousMonth() {
    this.calendar.currentDate = new Date(this.calendar.currentDate.setMonth(this.calendar.currentDate.getMonth() - 1));
  }

  nextMonth() {
    this.calendar.currentDate = new Date(this.calendar.currentDate.setMonth(this.calendar.currentDate.getMonth() + 1));
  }

  getMonthName(month: number): string {
    var monthName = "";

    switch (month) {
      case 0:
        monthName = "Janeiro"
        break;
      case 1:
        monthName = "Fevereiro"
        break;
      case 2:
        monthName = "Março"
        break;
      case 3:
        monthName = "Abril"
        break;
      case 4:
        monthName = "Maio"
        break;
      case 5:
        monthName = "Junho"
        break;
      case 6:
        monthName = "Julho"
        break;
      case 7:
        monthName = "Agosto"
        break;
      case 8:
        monthName = "Setembro"
        break;
      case 9:
        monthName = "Outubro"
        break;
      case 10:
        monthName = "Novembro"
        break;
      case 11:
        monthName = "Dezembro"
        break;
    }

    return monthName;
  }

  getFormatedDate(date: Date, adjustment: number) {
    return moment(date).add(adjustment, 'days').format("DD/MM/YYYY")
  }

  convertDatePattern(stringDate: string) {
    let pieces = stringDate.split('/')
    return pieces[1] + "-" + pieces[0] + "-" + pieces[2]
  }
}


// WEBPACK FOOTER //
// ./src/pages/eventos/eventos.ts